import React from 'react';
import { Helmet } from 'react-helmet-async';

const Services = ({ isHome }) => {
  const services = [
    {
      icon: <img src="/images/icons/DentisterieGeneral.png" alt="Dentisterie générale"  />,
      title: "Dentisterie générale",
      description: "Soins dentaires complets incluant nettoyages, obturations et traitements préventifs.",
      features: ["Bilan dentaire régulier", "Détartrage et nettoyage", "Soins des caries et extractions dentaires", "Traitements de canal (dévitalisation)"]
    },
    {
      icon: <img src="/images/icons/DentisterieEsthetique.png" alt="Dentisterie esthétique"  />,
      title: "Dentisterie esthétique",
      description: "Transformez votre sourire avec nos procédures dentaires esthétiques avancées.",
      features: ["Blanchiment dentaire", "Facettes", "Couronnes dentaires", "Transformation du sourire"]
    },
    {
      icon: <img src="/images/icons/ImplantsDentaires.png" alt="Implants dentaires"  />,
      title: "Implants dentaires",
      description: "Solutions de remplacement des dents permanentes pour un sourire d’apparence naturelle.",
      features: ["Implants unitaires", "Implants de pleine arc", "Prothèses dentaires sur implants", "Technique All-on-4"]
    },
        {
      icon: <img src="/images/icons/Orthodontie.png" alt="Orthodontie"  />,
      title: "Orthodontie",
      description: "Alignez vos dents avec des solutions orthodontiques modernes.",
      features: ["Appareils dentaires traditionnels", "Aligneurs transparents", "Contentions", "Orthopédie dento-faciale précoce chez l’enfant"]
    },
    {
      icon: <img src="/images/icons/DentisteriePediatrique.png" alt="Dentisterie pédiatrique"  />,
      title: "Dentisterie pédiatrique",
      description: "Des soins dentaires doux et adaptés aux enfants et aux adolescents.",
      features: ["Environnement rassurant et adapté aux enfants", "Évaluation orthodontique précoce", "Scellements dentaires préventifs", "Traitements au fluor pour renforcer les dents"]
    },
        {
      icon: <img src="/images/icons/SoinsUrgence.png" alt="Soins d'urgence"  />,
      title: "Soins d'urgence",
      description: "Soins dentaires d’urgence disponibles 24h/24 et 7j/7, quand vous en avez le plus besoin.",
      features: ["Soulagement de la douleur dentaire", "Réparation de dents cassées", "Remplacement de plombages perdus", "Extractions d'urgence"]
    }

  ];

    const handleAppointment = (e) => {
    e.preventDefault();

    const phoneNumber = process.env.REACT_APP_PHONE_NUMBER; // <-- WhatsApp number in international format

    const message = `Bonjour, je veux prendre un rendez-vous pour une consultation.`;

    const encodedMessage = encodeURIComponent(message);

    window.open(
      `https://wa.me/${phoneNumber}?text=${encodedMessage}`,
      "_blank"
    );
  };

  return (
    <>
      {!isHome && (
        <Helmet>
          <title>Nos Services Dentaires – Cabinet Dentaire Temara</title>
          <meta
            name="description"
            content="Découvrez nos services dentaires complets à Temara : dentisterie générale, esthétique, implants, orthodontie, pédiatrie et soins d'urgence."
          />
          <meta
            property="og:title"
            content="Nos Services Dentaires – Cabinet Dentaire Temara"
          />
          <meta
            property="og:description"
            content="Soins dentaires professionnels et personnalisés : prévention, traitement, esthétique et urgence. Prenez rendez-vous dès aujourd'hui !"
          />
          <meta
            property="og:image"
            content="https://centredentairetemara.ma/images/logo_horizontal_no_background.png"
          />
          <meta
            property="og:url"
            content="https://centredentairetemara.ma/services"
          />
          <meta property="og:type" content="website" />
        </Helmet>
      )}
      <section id="services" className="section-padding bg-gray-50 pt-24">
        <div className="container-custom">
          {/* Header */}
          <div className="text-center mb-16" data-aos="fade-up">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">
              Nos <span className="text-gradient">Services</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Nos services sont conçus pour répondre à tous vos besoins, de la
              prévention aux soins esthétiques avancés. Découvrez comment notre
              équipe dévouée met son expertise au service de votre sourire,
              offrant des solutions personnalisées et des résultats
              exceptionnels.
            </p>
          </div>

          {/* Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => {
              const slug = service.title.toLowerCase().replace(/\s+/g, "-");

              return (
                <div
                  key={index}
                  id={slug}
                  className="bg-white rounded-xl shadow-lg p-8 card-hover flex flex-col"
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <div className="text-center mb-6">
                    <div className="w-20 h-20 bg-blue-400 rounded-full flex items-center justify-center mx-auto mb-4">
                      {service.icon}
                    </div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-3">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {service.description}
                    </p>
                  </div>

                  {/* Features List */}
                  <div className="space-y-2 mb-6">
                    {service.features.map((feature, featureIndex) => (
                      <div
                        key={featureIndex}
                        className="flex items-center space-x-2"
                      >
                        <div className="w-2 h-2 bg-primary-500 rounded-full"></div>
                        <span className="text-sm text-gray-600">{feature}</span>
                      </div>
                    ))}
                  </div>

                  {/* CTA Button */}
                  {/* <button className="w-full mt-auto bg-gradient-to-r from-blue-400 to-gray-400 text-white font-semibold py-3 px-6 rounded-full transition-all duration-300 hover:shadow-lg transform hover:scale-105">
                  Learn More
                </button> */}
                </div>
              );
            })}
          </div>

          {/* Call to Action */}
          <div className="mt-16 text-center" data-aos="fade-up">
            <div className="bg-gradient-to-r from-blue-500 to-gray-500 rounded-2xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-4">
                Prêt(e) à transformer votre sourire ?
              </h3>
              <p className="text-lg mb-6 opacity-90">
                Prenez rendez-vous dès aujourd’hui et faites le premier pas vers
                un sourire plus sain et éclatant.
              </p>
              <button
                onClick={handleAppointment}
                className="bg-white text-primary-600 font-semibold py-3 px-8 rounded-lg hover:bg-gray-200 transition-colors duration-300"
              >
                Prendre rendez-vous
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services; 